<template>
    <div class="workOrderList">
        <div class="clearfix fixed">
            <van-nav-bar
                class="restclass"
                title="派工单总览"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>
        <div class="clientList">
            <van-row class="search">
                <van-col span="18"><van-search v-model="payload.keyword" placeholder="请输入搜索关键词" class="search" /></van-col>
                <van-col span="2">
                    <van-button type="primary" size="normal" round style="font-size:13px;margin-top:8px;"
                        @click="search">查&nbsp;询</van-button>
                </van-col>
                <van-col span="2" style="float:right; margin:5px 0px 0 15px !important;">
                    <van-icon name="scan" size="30" round title="扫一扫"
                        @click="scan" />
                </van-col>
            </van-row>
            <van-row>
                <van-col span="4"><van-button type="primary" size="normal" round style="font-size:13px;margin-top:-5px;"
                    @click="queryallList">全部</van-button></van-col>
                <van-col span="20">
                    <van-dropdown-menu active-color="#ee0a24">
                        <van-dropdown-item v-model="status" :options="optionStatus" @change="statusChange" />
                        <van-dropdown-item v-model="category" :options="optionCategory" @change="categoryChange" />
                    </van-dropdown-menu>
                </van-col>
            </van-row>
            <van-list
                v-model="fansLoading"
                :finished="fansFinished"
                finished-text="已加载全部"
                @load="loadMore">
                <div
                    v-for="(item,index) in list"
                    :key="item.Id"
                    class="list clearfix">
                    <!-- @click="onClientDetails(item.TerminalId,item.SN)" -->
                    <div class="clearfix">
                        <van-row>
                            <van-col span="1">{{ index + 1 }}</van-col>
                            <van-col span="20">
                                <p>
                                    <span class="info-span">{{ item.driver }}</span>
                                    <span class="info-span">{{ item.sheetNo }}</span>
                                    <!-- {{ item.totalWorkHour }} / -->
                                    <span class="info-span info-span-blue">{{ item.actualWorkHours }}</span>
                                </p>
                                <p>
                                    <span class="info-span">{{ item.owner }}</span>
                                    <span class="info-span-red">{{ item.category + "-" + item.vehicleCode + '-' + item.barCode }}</span>
                                </p>
                                <p>
                                    <span class="info-span"><van-tag round type="warning">{{ statusTranslate(item.enumWorkOrderStatus) }}</van-tag></span>
                                    <span style="width:30%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{ item.commitTime |parsetime }}</span>
                                </p>
                            </van-col>
                            <van-col v-if="$_has('maintain:workorderoverview:edit')" span="3" @click="queryDispatch(item.id)"><van-button type="primary" round>查看</van-button></van-col>
                            <!-- <van-col span="1"><span calss="info-span-red">{{ statusTranslate(item.enumWorkOrderStatus) }}</span></van-col> -->
                        </van-row>
                    </div>
                </div>
            </van-list>
            <p
                v-if="list.length === 0"
                class="noList">暂无数据</p>
        </div>
        <bottom />
    </div>
</template>

<script type="text/javascript">
var moment = require('moment')
import { Dialog, Toast } from 'vant'
// import { Icon, List, Button, Col, Row, DropdownMenu, DropdownItem, Search } from 'vant'
import bottom from '@/components/bottom'
import { getcategory } from '@/api/basics'
import { getWorkOrderList } from '@/api/maintain'
export default {
    name: 'WorkOrderList',
    components: {
        bottom
        // Icon, List, [Button.name]: Button, [Col.name]: Col, Row, DropdownMenu, DropdownItem, Search
    },
    filters: {
        parsetime(date1) {
            var date = new Date(date1)
            var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
            var currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
            var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            return date.getFullYear() + '-' + month + '-' + currentDate + ' ' + hours + ':' + minutes + ':' + seconds
        }
    },
    data() {
        return {
            fansLoading: false,
            fansFinished: false,
            payload: { sourcePage: 2, enumWorkOrderStatus: null, category: null, keyword: null, pageIndex: 1, pageSize: 10 },
            list: [],
            totalCount: 0,
            status: 0,
            category: 0,
            optionStatus: [
                { text: '全部', value: 0 },
                { text: '维修中', value: 3 },
                { text: '维修中-领料完成', value: 4 },
                { text: '维修中-质检不通过', value: 5 },
                { text: '维修完成', value: 6 },
                { text: '维修关闭', value: 7 }

            ],
            optionCategory: [
                { text: '全部', value: 1 },
                { text: '徐工', value: 2 },
                { text: '柳工', value: 3 }
            ],
            categoryDict: []
        }
    },
    watch: {
        status: function(val) {
            if (val >= 0) {
                if (val === 0) { this.payload.enumWorkOrderStatus = [] } else { this.payload.enumWorkOrderStatus = [val] }
            }
        },
        category: function(val) {
            var item = this.categoryDict.find(function(d) { return d.id === val })
            if (item) {
                this.payload.category = item.content
            } else {
                this.payload.category = null
            }
        }
    },
    created() {
    },
    async mounted() {
        window['scanit'] = data => {
            this.scanit(data)
        }
        if (this.$route.query.type == '车辆状态') {
            this.payload = {
                sourcePage: 2,
                enumWorkOrderStatus: null,
                category: null,
                barCode: this.$route.query.barCode,
                pageIndex: 1,
                pageSize: 10
            }
            this.payload.isApp=1
            this.fansLoading = true
            this.list = []
            this.getList()
            // const response = await getWorkOrderList(this.payload)
            // if (response.isSuccess) {
            //     this.fansLoading = false
            //     this.list = response.data
            //     this.totalCount = response.totalCount
            // }
        }
        this.init()
    },
    methods: {
        init: function() {
            getcategory().then(response => {
                this.categoryDict = response.data
                this.optionCategory = [{ text: '全部', value: 0 }].concat(response.data.map(c => { return { text: c.content, value: c.id } }))
            })
            this.queryList()
        },
        getBack() {
            this.$router.push({ path: '/' })
        },
        loadMore() {
            if (!this.fansFinished) {
                this.payload.pageIndex++
                this.fansLoading = true
                this.payload.isApp=1
                // getWorkOrderList(this.payload).then(response => {
                //     this.list.push.apply(this.list, response.data)
                //     // this.list = this.list.concat(response.data)
                //     this.totalCount = response.totalCount
                // }).finally(this.afterLoad)
                this.getList()
            }
        },
        search() {
            this.payload.pageIndex = 1
            this.queryList()
        },
        queryList() {
            this.fansLoading = true
            this.payload.isApp=1
            // getWorkOrderList(this.payload).then(response => {
            //     this.list = response.data
            //     this.totalCount = response.totalCount
            // }).finally(this.afterLoad)
            this.list = []
            this.getList()
        },
        getList(){
            getWorkOrderList(this.payload).then(response => {
                this.fansLoading = false
                this.list.push.apply(this.list, response.data)
                this.totalCount = response.totalCount

                this.list.forEach(item=>{
                    if(item.confirmTime && (item.completeTime || item.repairCompleteTime)){
                        let completeTIme = item.repairCompleteTime ? item.repairCompleteTime : item.completeTime;
                        let diffTime = moment(completeTIme).diff(moment(item.confirmTime));
                        item.actualWorkHours = (diffTime / (1000 * 60) / 60).toFixed(2) 
                    }
                })
                
            }).finally(this.afterLoad)
        },
        queryallList() {
            this.status = 0
            this.category = 0
            this.payload = {
                sourcePage: 2,
                enumWorkOrderStatus: null,
                category: null,
                keyword: null,
                barCode: '',
                pageIndex: 1,
                pageSize: 10
            }
            this.queryList()
        },
        statusChange() {},
        statusTranslate(status) {
            var item = this.optionStatus.find(s => { return s.value == status })
            if (item) { return item.text }
            return status
        },
        categoryChange() {},
        scan() {
            window.test.ToScan()
        },
        async scanit(val) {
            this.payload.pageIndex = 1
            this.payload.barCode = val
            this.fansLoading = true
            this.payload.isApp=1
            // const response = await getWorkOrderList(this.payload)
            // if (response.isSuccess) {
            //     this.fansLoading = false
            //     this.list = response.data
            //     this.totalCount = response.totalCount
            // }
            this.list = []
            this.getList()
            // this.queryList()
        },
        afterLoad() {
            this.fansLoading = false
            this.fansFinished = this.list.length == this.totalCount
        },
        queryDispatch(val) {
            if (this.$_has('maintain:workorder:view')) {
                this.$router.push({
                    path: '/dispatchList',
                    query: { id: val, type: '处理' }
                })
            } else {
                this.$router.push({
                    path: '/404'
                })
            }
        }
    }
}
</script>

<style lang='scss'>
.workOrderList {
    width: 100%;
  .logout{
    margin-top: -20px;
    color: blue;
  }
  .clientList{
    margin-bottom: 100px;
    padding: 0px 20px;
    .span-index{
        background:#07c160;border-radius:5px;color:#fff; margin-top:3px;text-align:center
    }
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
      margin:10px 0;
      button{
        width: 100px;
        height: 50px;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      //border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
      .info-span {
    display:inline-block;
    padding:0px 8px;
    color:#000;
    width:30%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    }
    .info-span-blue{
        color: #3498db;
        font-size: 30px;
    }
    .info-span-red {
        padding:0px 8px;
        color:#f00;
        width:40%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    }
  }
}
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}

.noList{
    text-align: center;
    margin-top: 50%;
    font-size: 26px;
    color: #ccc;
}
.listMore{
    text-align: center;
    font-size: 26px;
    color: rgb(204, 204, 204);
}
.right-top-box{
    width:100px;
    height:100px;
    background-color: #555;
    color: #fff;
    /* Rotate div */
    transform:rotate(45deg);
    ms-transform:rotate(45deg); /* Internet Explorer */
    moz-transform:rotate(45deg); /* Firefox */
    webkit-transform:rotate(45deg); /* Safari 和 Chrome */
    o-transform:rotate(45deg); /* Opera */

    position: absolute;
    right: -50px;
    top: -50px;
}
</style>
